export default __webpack_public_path__ + "static/media/sos-logo.709e7c84.svg";